module.exports = __webpack_public_path__ + "files/9722ff4a5231750af0ae20469ff987ac.png";